import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeEmbedSectionRaw'
 * @name TypeEmbedSectionRawFields
 * @type {TypeEmbedSectionRawFields}
 * @memberof TypeEmbedSectionRaw
 */
export interface TypeEmbedSectionRawFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'embedCode' (Embed Code)
     * @name Embed Code
     * @localized false
     */
    embedCode: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'embedSectionRaw' (Embed Section (RAW))
 * @name TypeEmbedSectionRawSkeleton
 * @type {TypeEmbedSectionRawSkeleton}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2019-07-17T12:24:44.551Z
 * @version 5
 */
export type TypeEmbedSectionRawSkeleton = EntrySkeletonType<TypeEmbedSectionRawFields, "embedSectionRaw">;
/**
 * Entry type definition for content type 'embedSectionRaw' (Embed Section (RAW))
 * @name TypeEmbedSectionRaw
 * @type {TypeEmbedSectionRaw}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2019-07-17T12:24:44.551Z
 * @version 5
 */
export type TypeEmbedSectionRaw<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeEmbedSectionRawSkeleton, Modifiers, Locales>;

export function isTypeEmbedSectionRaw<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeEmbedSectionRaw<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'embedSectionRaw'
}
